import { useContext } from 'react';
import PortfolioItemContext from '../../PortfolioItemContext';
import ShouldGetImagesFromPublicApiContext from '@/components/FileAttachments/ShouldGetImagesFromPublicApiContext';
import useImageFileStatusRefreshing, {
  type ImageLocalStateUpdater,
} from '@/lib/files/useFileStatusRefreshing';

const useThumbnailFileStatusRefreshing = (): void => {
  const {
    portfolioItem,
    setPortfolioItem,
    setPortfolioItemSummary,
    portfolioItemApiEndpoint,
  } = useContext(PortfolioItemContext);
  const thumbnail = portfolioItem.thumbnail!;

  const shouldGetImagesFromPublicApi = useContext(
    ShouldGetImagesFromPublicApiContext,
  );

  useImageFileStatusRefreshing(
    `${portfolioItemApiEndpoint}/thumbnail/${thumbnail.id}/status${shouldGetImagesFromPublicApi ? '/public' : ''}`,
    portfolioItem.thumbnail!,
    (stateUpdater: ImageLocalStateUpdater): void => {
      setPortfolioItem(portfolioItem => {
        stateUpdater(portfolioItem.thumbnail);
      });

      setPortfolioItemSummary(portfolioItemSummary => {
        stateUpdater(portfolioItemSummary.thumbnail);
      });
    },
  );
};

export default useThumbnailFileStatusRefreshing;
